<template>
  <div style="margin: 10px 20px 0px">
  <el-form style="margin-right: 30px" :model="addAccForm" :rules="addAccRules" ref="addAccForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="用户名" prop="username">
        <el-input v-model="addAccForm.username" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="addAccForm.password" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item label="权限" prop="role">
        <el-select v-fixZoom v-model="addAccForm.role" filterable placeholder="请选择权限" style="width: 100%">
          <el-option
            v-for="item in roleOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <div v-if="!isAddUser">
        <el-form-item v-if="addAccForm.role !== 'company'" label="所属人员" prop="spid">
          <el-select v-fixZoom filterable v-model="addAccForm.spid" placeholder="请选择所属人员" style="width: 100%">
            <el-option
              v-for="item in personOptions"
              :key="item.value"
              :label="item.name"
              :value="item.id">
              <span style="float: left">{{ item.name }}&nbsp;-&nbsp;</span>
              <span style="float: left; color: #8492a6; font-size: 12px">{{ item.jobnum }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-else label="所属人员" prop="supplier_pid">
          <el-select v-fixZoom filterable v-model="addAccForm.supplier_pid" placeholder="请选择所属人员" style="width: 100%">
            <el-option
              v-for="item in supplierOptions"
              :key="item.value"
              :label="item.name"
              :value="item.id">
              <span style="float: left">{{ item.name }} - </span>
              <span style="float: left; color: #8492a6; font-size: 13px">{{ item.jobnum }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="模块" prop="moduletag" v-if="ismoduletag">
        <el-checkbox-group v-model="addAccForm.moduletag">
          <el-checkbox label="居家"></el-checkbox>
          <el-checkbox label="机构"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="客服分组" v-if="addAccForm.role === 'csd' && moduletag !== 2">
        <el-radio-group v-model="addAccForm.customerservicetag">
          <el-radio label="2">计生</el-radio>
          <el-radio label="1">话务</el-radio>
          <el-radio label="3">外勤</el-radio>
          <el-radio label="4">话务/外勤</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div>
      <el-row style="margin: 0 30px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAdd()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddAcc('addAccForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 30px"></div>
  </div>
</template>

<script>
import {adduser} from '../../../api/account'

export default {
  name: 'accountAdd',
  model: {
    prop: 'addShow',
    event: 'change'
  },
  props: {
    accountAddRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      personOptions: [],
      supplierOptions: [],
      ismoduletag: true,
      roleOptions: [
        {value: 'superadmin', label: '超级管理者'},
        {value: 'admin', label: '管理者'},
        {value: 'op', label: '运营'},
        {value: 'csd', label: '客服'},
        {value: 'guest', label: '访客'},
        {value: 'company', label: '服务商'},
        { value: 'sv', label: '监管' }
      ],
      addAccForm: {
        id: 0,
        username: '',
        password: '',
        role: '',
        spid: '',
        supplier_pid: '',
        moduletag: [],
        customerservicetag: ''
      },
      addAccRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入账号密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
        ],
        spid: [
          { required: true, message: '请选择平台人员', trigger: 'change' }
        ],
        supplier_pid: [
          { required: true, message: '请选择服务商人员', trigger: 'change' }
        ],
        moduletag: [
          { type: 'array', required: true, message: '请至少选择一个模块', trigger: 'change' }
        ],
        role: [
          { required: true, message: '请选择权限', trigger: 'change' }
        ]
      },
      moduletag: '',
      isAddUser: false // 新建员工
    }
  },
  created () {
    // 1、account.vue账号页面。 2、userAdd.vue 新建员工弹窗添加账号
    // console.log(this.accountAddRow)
    this.getData()
    this.moduletag = this.$store.state.user.moduletag
    if (this.moduletag === 2) { // 机构
      this.addAccForm.moduletag = ['机构']
      this.ismoduletag = false
    } else if (this.moduletag === 1) { // 居家
      this.addAccForm.moduletag = ['居家']
      this.ismoduletag = false
    } else {
      // 3
      this.ismoduletag = true
    }
  },
  mounted () {
  },
  methods: {
    getData () {
      if (this.accountAddRow.isAddUser) {
        this.isAddUser = this.accountAddRow.isAddUser
      }
      this.personOptions = this.accountAddRow.persons
      this.supplierOptions = this.accountAddRow.supplierorgpersons
      let role = this.$store.state.user.role
      if (role !== 'superadmin') {
        this.roleOptions = [
          { value: 'admin', label: '管理者' },
          { value: 'op', label: '运营' },
          { value: 'csd', label: '客服' },
          { value: 'guest', label: '访客' },
          { value: 'company', label: '服务商' },
          { value: 'sv', label: '监管' }
        ]
      }
      if (this.$store.state.user.moduletag === 2) {
        this.roleOptions = [
          { value: 'admin', label: '管理员' },
          { value: 'csd', label: '值班员' },
          { value: 'guest', label: '护工' }
        ]
      }
    },
    submitAddAcc (formName) {
      // console.log(this.addAccForm.moduletag)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addAccForm.role === 'company') {
            this.addAccForm.spid = 0
          } else {
            this.addAccForm.supplier_pid = 0
          }
          if (this.isAddUser) {
            this.golobleObject.addAccUser(this.addAccForm)
            this.$emit('change', false)
            return
          }
          let moduletag = ''
          if (this.addAccForm.moduletag.length === 2) {
            moduletag = 3
          } else if (this.addAccForm.moduletag[0] === '居家') {
            moduletag = 1
          } else if (this.addAccForm.moduletag[0] === '机构') {
            moduletag = 2
          }
          let customerservicetag = ''
          if (this.addAccForm.customerservicetag === '') {
            customerservicetag = 0
          } else {
            customerservicetag = parseInt(this.addAccForm.customerservicetag)
          }
          let data = {
            id: this.addAccForm.id,
            username: this.addAccForm.username,
            password: this.addAccForm.password,
            role: this.addAccForm.role,
            spid: this.addAccForm.spid,
            supplier_pid: this.addAccForm.supplier_pid,
            moduletag: moduletag,
            customerservicetag: customerservicetag
          }
          adduser(data).then(res => {
            this.$notify({
              title: '成功',
              message: '成功新建账号',
              type: 'success',
              duration: 2000
            })
            this.golobleObject.updateTableAcc()
            this.$emit('change', false)
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '新建账号失败'
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeAdd () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/accountAdd.vue